import { cookieId } from '../constants'

/**
 * Set the experiment cookie's value.
 * @param {String} expId use null to unset the cookie, otherwise the experiment id
 * @param {String} userId the user's id
 * @param {Date} expiration the expiration date of the experiment
 */
export function setExpCookie(expId, userId, expiration) {
  let cookieDataStr

  let cachedCookie

  if (expId && userId && expiration) {
    cachedCookie = {
      expId,
      userId,
    }
    cookieDataStr = JSON.stringify(cachedCookie)
    document.cookie =
      cookieId + '=' + cookieDataStr + '; expires=' + expiration + '; path=/'
    //@ts-ignore
    if (window.ga) {
      //@ts-ignore
      window.ga('set', 'userId', expId + '|' + userId)
    }
  } else {
    document.cookie =
      cookieId + '=; expires=' + new Date(0).toUTCString() + '; path=/'
  }
}
